export default {
  clean: () => import("/tmp/build_dab1367c/layouts/clean.vue").then(m => m.default || m),
  default: () => import("/tmp/build_dab1367c/layouts/default.vue").then(m => m.default || m)
}